import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Removed TypeScript interfaces

const initialState = {
  services: [],
  loading: false,
  error: null,
};

export const fetchServicesByLocation = createAsyncThunk(
  'services/fetchServicesByLocation',
  async (location) => {
    const response = await api.get('/services/services', { params: { location } });
    return response.data.data;
  }
);

export const addServiceRating = createAsyncThunk(
  'services/addServiceRating',
  async ({ serviceId, userId, rating, comment }) => {
    const response = await api.post(`/services/services/${serviceId}/rate`, { userId, rating, comment });
    return response.data.data;
  }
);

export const addServiceBookmark = createAsyncThunk(
  'services/addServiceBookmark',
  async ({ serviceId, userId }) => {
    const response = await api.post(`/services/services/${serviceId}/bookmark`, { userId });
    return response.data.data;
  }
);

export const removeServiceBookmark = createAsyncThunk(
  'services/removeServiceBookmark',
  async ({ serviceId, userId }) => {
    const response = await api.delete(`/services/services/${serviceId}/bookmark`, { data: { userId } });
    return response.data.data;
  }
);

const serviceSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServicesByLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServicesByLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.services = action.payload;
      })
      .addCase(fetchServicesByLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Failed to fetch services';
      });
  },
});

export default serviceSlice.reducer;
